<script setup lang="ts">
import { MMPopupFullScreen } from "@mm-frontend/mm-web-ui-kit";
import AppSearchResults from './AppSearchResults.vue';
</script>

<template>
  <MMPopupFullScreen class="app-search-results-mobile-popup" data-id="app-search-results-mobile-popup">
    <AppSearchResults />
  </MMPopupFullScreen>
</template>

<style scoped lang="stylus">
.app-search-results-mobile-popup
  background-color var(--background-secondary)
  padding-bottom 16px
</style>